import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import useUploadSelector from "./useUploadSelector";

const StyledColDiv = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "column",
  alignItems: "center",
  padding: 40,
});

const StyledImg = styled("img")({
  width: 150,
  height: 80,
  marginTop: 30,
});

interface Data {
  email: string;
  dealerLogo?: string;
}

interface UploadWidgetProps {
  data: Data;
  createAcct: boolean;
  setUser?: React.Dispatch<React.SetStateAction<any>>;
}

const UploadWidget: React.FC<UploadWidgetProps> = React.memo(({ data, createAcct, setUser }) => {
  const { showWidget } = useUploadSelector(data, createAcct, setUser || null);

  return (
    <StyledColDiv>
      <Button variant="contained" color="primary" onClick={showWidget}>
        Upload Logo
      </Button>
      {data.dealerLogo && <StyledImg src={data.dealerLogo} alt="" />}
    </StyledColDiv>
  );
});

export default UploadWidget;
